import axios from "axios";
const baseUrl = process.env.REACT_APP_API_URL || "";
const clientAxios = axios.create({
  baseURL: `${baseUrl}/api`,
});

clientAxios.interceptors.request.use(function (config) {
  const token = localStorage.getItem('JWT');
  config.headers['auth-token'] = token ? token : '';
  return config;
});

export default clientAxios;
